<template>
    <div :class="colClass">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'GridCol',
    props: ['bp', 'size'],
    computed: {
        colClass() {
            return `grid__col_${ this.bp }_${ this.size }`
        },
    },
}
</script>